/*
 * Форматы фото-страниц Comabooks — зеркало backend/src/data/comabooksPhotos.ts.
 * В photos.position пишется `cb:<status>`.
 */

export type ComabooksPhotoStatus = 'top' | 'center' | 'bottom' | 'vertical' | 'square' | 'horizontal';

export const COMABOOKS_FULLSCREEN: ComabooksPhotoStatus[] = ['center', 'top', 'bottom'];
export const COMABOOKS_FRAMED: ComabooksPhotoStatus[] = ['vertical', 'square', 'horizontal'];
const ALL: ComabooksPhotoStatus[] = [...COMABOOKS_FULLSCREEN, ...COMABOOKS_FRAMED];

export const COMABOOKS_PHOTO_PREFIX = 'cb:';

export const isFramedStatus = (s: ComabooksPhotoStatus): boolean =>
  s === 'vertical' || s === 'square' || s === 'horizontal';

export const encodeComabooksPhoto = (s: ComabooksPhotoStatus): string => `${COMABOOKS_PHOTO_PREFIX}${s}`;

const isStatus = (v: string): v is ComabooksPhotoStatus => (ALL as string[]).includes(v);

/** `cb:<status>`, сырые legacy-статусы и кодировку Lovestoria → формат Comabooks. */
export function decodeComabooksPhoto(position: string | null | undefined): ComabooksPhotoStatus {
  const raw = (position ?? '').trim();
  if (raw.startsWith(COMABOOKS_PHOTO_PREFIX)) {
    const s = raw.slice(COMABOOKS_PHOTO_PREFIX.length);
    return isStatus(s) ? s : 'center';
  }
  if (isStatus(raw)) return raw;
  const [preset, , desc] = raw.split('::');
  if (preset === 'portrait' || preset === 'portrait-tall') return 'vertical';
  if (preset === 'square') return 'square';
  if (preset === 'landscape' || preset === 'landscape-wide') return 'horizontal';
  if (preset === 'fullbleed') {
    const pos = (desc ?? '').split(':')[0];
    return pos === 'top' || pos === 'bottom' ? pos : 'center';
  }
  return 'center';
}

export const COMABOOKS_PHOTO_LABELS: Record<ComabooksPhotoStatus, string> = {
  center: 'По центру',
  top: 'Сверху',
  bottom: 'Снизу',
  vertical: 'Вертикально',
  square: 'Квадрат',
  horizontal: 'Горизонтально',
};
